import * as React from 'react';
const GalleryIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M9 22.39h6c5 0 7-2 7-7v-6c0-5-2-7-7-7H9c-5 0-7 2-7 7v6c0 5 2 7 7 7Z"
		/>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M9 10.39a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM2.67 19.2l4.93-3.31c.79-.53 1.93-.47 2.64.14l.33.29c.78.67 2.04.67 2.82 0l4.16-3.57c.78-.67 2.04-.67 2.82 0L22 14.39"
		/>
	</svg>
);
export default GalleryIcon;
